import React, { useMemo } from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileText } from "lucide-react";
import NoDocument from "./NoDocument";

const CompensationDocument = ({ documents = [] }) => {
    const compensationDocs = useMemo(() => {
        return documents?.filter(doc => 
            doc?.doc_type_name === 'Compensation'
        );
    }, [documents]);

    if (compensationDocs.length === 0) {
        return (
            <>
                <NoDocument docType="Compensation"/>
            </>
        );
    }

    return (
        <div className="space-y-3">
            {compensationDocs.map((doc) => (
                <DocumentCard
                    key={doc.doc_id}
                    title={doc.doc_title}
                    description={doc.doc_description}
                    status={doc.doc_status_name}
                    date={doc.doc_date}
                    size={doc.doc_size}
                    icon={<FileText className="w-5 h-5 text-emerald-600" />}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default CompensationDocument;
